<template>
  <div
    class="flex items-center p-4 border-b cursor-pointer"
    @click="onFavClick"
  >
    <NumImage
      class="mr-4"
      :main-loaded="mainLoaded"
      :controller="json && json.controller"
      :result="json"
      :src="favouriteSrc"
      :url="favourite.numUriString"
      @json-changed="onNumImageJsonChange"
    />
    <FavouriteItemMain :num-uri="favourite.numUriString" :json="mainResult" />
    <ion-icon
      name="chevron-forward-outline"
      class="flex-shrink-0 fs-3 ml-auto"
    ></ion-icon>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

import router from "@/router";

import FavouriteItemMain from "@/views/Home/Favourite/ItemMain";
import NumImage from "@/views/Home/NumImage";

import numQuery from "@/mixins/numQuery";

import { UPDATE_FAVOURITE } from "@/store/types/mutations";

import { chooseImage, formatNumUriString } from "@/utils/utils";

export default {
  name: "FavouriteItem",
  mixins: [numQuery],
  components: {
    FavouriteItemMain,
    NumImage,
  },
  props: {
    favourite: Object,
  },
  data() {
    return {
      moduleId: 1,
    };
  },
  computed: {
    ...mapState(["favourites"]),
    favouriteSrc() {
      return chooseImage(this.favourite?.results?.[3]?.images);
    },
    mainLoaded() {
      return !!this.favourite?.results?.[1];
    },
    mainResult() {
      return this.favourite?.results?.[1] || this.json;
    },
  },
  watch: {
    favourite: {
      handler(newVal) {
        // if we don't have a record saved in vuex for this module with this fav
        if (!newVal?.results?.[1]) this.getNumResult(newVal.numUriString);
      },
      immediate: true,
    },
    json(newVal) {
      this.UPDATE_FAVOURITE({
        numUriString: this.favourite.numUriString,
        results: {
          1: newVal,
        },
      });
    },
  },
  methods: {
    ...mapMutations([UPDATE_FAVOURITE]),
    onFavClick() {
      const parsedNumUri = formatNumUriString(this.favourite.numUriString);
      router.push({ query: { s: parsedNumUri } });
    },
    onNumImageJsonChange(json) {
      this.UPDATE_FAVOURITE({
        numUriString: this.favourite.numUriString,
        results: {
          3: json,
        },
      });
    },
  },
};
</script>
